import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InternalListScreen';
import InternalList from './InternalListScreen';
import { StoreState } from 'src/store/reducers';
import { getInternals } from '../../../../../../../../store/actions/internal-actions';
import { QueryParams } from '../../../../../../../../types/grid';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.internals.data,
        inProgress: state.internals.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getInternals(params)),
    };
}

const InternalListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InternalList);

export default InternalListScreen;
